/* eslint-disable */
import React from "react";
import { Route, Router, Switch, Redirect } from "react-router";
// import DashboardsModule from "../modules/dashboards";
import HomePage from "../pages/HomePage/HomePage";
import HelpPage from "../pages/HelpPage/HelpPage";
import ContactPage from "../pages/ContactPage/ContactPage";
import { useAuth } from "../modules/auth/shared/hooks/useAuth";
import UserModule from "../modules/user";
import { dataPrivacy } from "../modules/privacy/components";
import NewsModule from "../modules/news";
import FavouritesModule from "../modules/favourites";
import MapModule from "../modules/map";
import ReportingModule from "../modules/reportng";
import SourceManualPage from "../pages/SourceManualPage/SourceManualPage";
import DataUpdatesPage from "../pages/DataUpdatesPage/DataUpdatesPage";
import AuthRouter from "../modules/auth/pages/AuthRouter";
import AdminPage from "../pages/AdminBlockPage/AdminBlockPage";
import DepartmentsPage from "../pages/DepartmentBlockPage/AdminBlockPage";
import BulkExportModule from "../modules/bulkexport";
import SubscriptionsModule from "../modules/subscriptions";
import SlidesPage from "../pages/SlidesPage";
import { ProtectedMigrationRoute } from "./ProtectedMigrationRoute";
import { browserHistory } from "./history";
import ExpiredPasswordLinkPage from "../modules/auth/pages/ExpiredPasswordPage/ExpiredPasswordLinkPage/ExpiredPasswordLinkPage";
import ExpiredPasswordPage from "../modules/auth/pages/ExpiredPasswordPage/ExpiredPasswordPage";
// import ReportPage from "../pages/ReportPage";

const AppRouter: React.FC = () => {
  const [isAuth] = useAuth();
  const isPasswordExpired = localStorage.getItem("isPasswordExpired");
  return (
    <Router history={browserHistory}>
      <Switch>
        <Route path="/login" component={AuthRouter} />
        <Route exact path={`/expired_password`} component={ExpiredPasswordLinkPage} />
        {!isAuth && <Route path="/privacy" component={dataPrivacy} />}
        {!isAuth && <Redirect from="*" to="/login" />}
        {isAuth && !isPasswordExpired && (
          <>
            <ProtectedMigrationRoute exact path="/help" component={HelpPage} />
            <ProtectedMigrationRoute exact path="/favourites" component={FavouritesModule} />
            <ProtectedMigrationRoute exact path="/contact" component={ContactPage} />
            <ProtectedMigrationRoute exact path="/SourceManual" component={SourceManualPage} />
            <ProtectedMigrationRoute exact path="/DataUpdates" component={DataUpdatesPage} />
            <Route path="/user" component={UserModule} />
            <Route path="/users" component={AdminPage} />
            <ProtectedMigrationRoute path="/departments" component={DepartmentsPage} />
            <ProtectedMigrationRoute exact path="/news" component={NewsModule} />
            <ProtectedMigrationRoute path="/bulk-export" component={BulkExportModule} />
            <ProtectedMigrationRoute exact path="/slides" component={SlidesPage} />
            <ProtectedMigrationRoute exact path="/subscriptions" component={SubscriptionsModule} />
            <ProtectedMigrationRoute path="/slides/:reportId" component={ReportingModule} />
            <ProtectedMigrationRoute path="/maps" component={MapModule} />
            <ProtectedMigrationRoute exact path="/" component={HomePage} />
            {/* TODO Add page not found */}
          </>
        )}
        <Route exact path="/login/password-expired" component={ExpiredPasswordPage} />
        {isAuth && isPasswordExpired && <Redirect from="*" to="/expired_password" />}
      </Switch>
    </Router>
  );
};

export default AppRouter;
